module.exports = __webpack_public_path__ + "assets/img/HealthcareSolutions-banner.017f58a9.png";